export default "__VITE_PUBLIC_ASSET__21ae4b40__"